import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

export default new Vuex.Store({
    // 设置属性
    state: {
      anthenticated: false
    },
  
    // 获取属性状态
    getters: {
      anthenticated: state => state.anthenticated
    },
  
    // 设置属性状态
    mutations: {
      // 保存登录状态
      isLogin (state, flag) {
        state.anthenticated = flag
      }
    },
    actions: {
      userLogin ({commit}, flag) {
        commit('isLogin', flag)
      }
    }
  })
  